import camelCase from "lodash/fp/camelCase";

export default function upperCamelCase(str) {
  return camelCase(str).replace(/^./, (str) => str.toUpperCase());
}
